import { render, staticRenderFns } from "./DetailCorrectScoreLock.vue?vue&type=template&id=d31251ae&scoped=true"
import script from "./DetailCorrectScoreLock.vue?vue&type=script&lang=js"
export * from "./DetailCorrectScoreLock.vue?vue&type=script&lang=js"
import style0 from "./DetailCorrectScoreLock.vue?vue&type=style&index=0&id=d31251ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31251ae",
  null
  
)

export default component.exports